import { createSelector } from '@ngrx/store';

import {
  addressFormFeature,
  type AddressFormState,
} from './address-form.state';

export const selectAddressState = createSelector(
  addressFormFeature,
  (state: AddressFormState) => state
);
